import { extendTailwindMerge } from 'tailwind-merge';

// ─── Por qué existe este archivo ──────────────────────────────────────────────
// `tailwind-merge` decide qué clases se contradicen con una lista interna de
// nombres. Conoce los de Tailwind (`text-sm`, `shadow-lg`…) pero NO los del
// design system. Al ver un nombre desconocido tras `text-` asume que es un
// COLOR, porque los colores admiten cualquier nombre. Entonces cree que
// `text-button` y `text-fg-on-brand` son dos colores peleando y borra el tamaño:
//
//   twMerge('text-button', 'text-fg-on-brand')  →  'text-fg-on-brand'   ✗
//   cn(      'text-button', 'text-fg-on-brand')  →  ambas               ✓
//
// Lo mismo con `shadow-standard`, que sin registrar se toma por un color de
// sombra y por eso no se puede anular con otra sombra.
//
// ⚠️ Estas listas deben coincidir con las claves de `fontSize` y `boxShadow` de
// `tailwind.config.js`. Si se añade un rol allá, hay que añadirlo acá.

export const DESIGN_SYSTEM_FONT_SIZES = [
  'title-1',
  'title-2',
  'title-3',
  'subtitle-1',
  'subtitle-2',
  'body-1',
  'body-2',
  'button',
  'caption',
  'overline-1',
  'overline-2',
] as const;

export const DESIGN_SYSTEM_SHADOWS = ['xs', 'standard'] as const;

/**
 * El `twMerge` del proyecto: idéntico al de `tailwind-merge` pero enseñado a
 * reconocer los tokens del design system.
 *
 * **Úsalo en lugar de importar `twMerge` directamente**, o los tamaños
 * tipográficos se perderán en silencio al combinarse con un color.
 */
export const cn = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...DESIGN_SYSTEM_FONT_SIZES] }],
      shadow: [{ shadow: [...DESIGN_SYSTEM_SHADOWS] }],
    },
  },
});
